module.exports = __webpack_public_path__ + "assets/img/2.fd5ffd64.png";